export default __webpack_public_path__ + "static/projuno-76fbe5681c2c95731933083902c50206.png";